import React from "react";
import { Box, Typography, Container, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BlockIcon from "@mui/icons-material/Block";
import { useRbac } from "../../hooks/RbacContext";

const Unauthorized = () => {
  const navigate = useNavigate();
  const { permissions } = useRbac();

  return (
    <Container>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          textAlign: "center",
        }}
      >
        <BlockIcon sx={{ fontSize: 60, color: "error.main", mb: 2 }} />
        <Typography variant="h4" component="h1" gutterBottom>
          Access Denied
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          You don't have permission to access this page.
        </Typography>
        {permissions?.globalRole?.role_id && permissions?.globalRole?.role_id === 13 ? (
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/timesheet")}
            sx={{ mt: 2 }}
          >
            Go to Timesheet
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/projects")}
            sx={{ mt: 2 }}
          >
            Go to Projects
          </Button>
        )}
      </Box>
    </Container>
  );
};

export default Unauthorized;
